const part = (label, s) => (s ? `${label} ${s.made}/${s.att}${s.pct != null ? ` (${s.pct}%)` : ''}` : null);

const DD = [['points', 'PTS', 'pts'], ['rebounds', 'REB', 'reb'], ['assists', 'AST', 'ast']];

// Live double-double: "PTS 14 · REB 8 · AST 3 — needs 2 reb" (closest two categories to 10).
const ddText = (p) => {
  const rows = DD.map(([k, lbl, u]) => ({ lbl, u, v: p[k] ?? 0 }));
  const gaps = rows.filter((r) => r.v < 10).map((r) => ({ ...r, gap: 10 - r.v })).sort((a, b) => a.gap - b.gap);
  const need = Math.max(0, 2 - rows.filter((r) => r.v >= 10).length);
  const tail = need ? `needs ${gaps.slice(0, need).map((g) => `${g.gap} ${g.u}`).join(' + ')}` : 'DOUBLE-DOUBLE ✓';
  return `${rows.map((r) => `${r.lbl} ${r.v}`).join(' · ')} — ${tail}`;
};

// NBA field-goal and 3-point shooting for points / threes legs.
export default function ShootingLine({ leg, className = '' }) {
  if (leg.stat_target === 'dd' && leg.dd_parts) {
    return <div className={`font-mono ${className}`} data-testid={`leg-dd-${leg.id}`}>{ddText(leg.dd_parts)}</div>;
  }
  const s = leg.shooting;
  if (!s || (leg.league || '').toLowerCase() !== 'nba') return null;
  const text = [part('FG', s.fg), part('3PT', s.three)].filter(Boolean).join(' · ');
  if (!text) return null;
  return <div className={`font-mono ${className}`} data-testid={`leg-shooting-${leg.id}`}>{text}</div>;
}
